module.exports = __webpack_public_path__ + "static/media/AI_Image_Analysls.0d223d68.svg";